import { forwardRef } from 'react';
import type { ChipSize, ChipVariant } from './Chip';

import { Chip } from './Chip';

export type ChoiceChipProps = {
  size?: ChipSize;
  variant?: ChipVariant;
  disabled?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  className?: string;
  children: React.ReactNode;
};

export const ChoiceChip = forwardRef<HTMLButtonElement, ChoiceChipProps>(
  function ForwardedChoiceChip(
    {
      size = 'md',
      variant = 'solid',
      disabled = false,
      onClick,
      isSelected = false,
      className,
      children,
      ...rest
    }: ChoiceChipProps,
    ref
  ) {
    return (
      <Chip
        {...rest}
        color={isSelected ? 'blue' : 'gray'}
        size={size}
        variant={isSelected ? variant : 'outline'}
        disabled={disabled}
        onClick={onClick}
        className={className}
        ref={ref}
      >
        {children}
      </Chip>
    );
  }
);
